import { ClickRedirectTypeSchema as r, DomainNameSchema as n, CampaignStatusSchema as t, CampaignGroupIdSchema as c, AdTypeSchema as h, UserIdSchema as g } from "@hprofits/shared";
import { z as a } from "zod";
import "../ad-group/contract.js";
import { PricingRuleSetDetailedStatusSchema as C, AdGroupListSchema as l, AdGroupSchema as y, PricingRuleOutputSchema as G } from "../ad-group/schemas.js";
import "@hprofits/shared/errors";
import "@hprofits/utils/zod";
import { createViewSchemas as p } from "../common/acl-view.js";
import "@hprofits/utils";
import "@orpc/contract";
import "@orpc/openapi";
import "../swagger/security.js";
import "../swagger/tags.js";
import { OwnerSchema as A } from "../common/owner.js";
import "../common/params.js";
import { paginatedList as w, PaginationSchema as L, SortingSchema as b } from "../common/pagination.js";
import "../creative-group/contract.js";
import { CreativeGroupListSchema as x, CreativeGroupCommonViewSchema as f } from "../creative-group/schemas.js";
import "../target-group/contract.js";
import { TargetGroupListSchema as I, TargetGroupListViewSchema as R } from "../target-group/schemas.js";
const o = 30, m = a.string().trim().min(1, "name must be non-empty").max(o, `name must be at most ${o} characters`), i = a.object({
  clickRedirectType: r
}).strict(), T = i.readonly(), j = i.extend({
  redirectDomain: n.optional()
}).readonly(), ra = a.union([T, j]), s = i.extend({
  name: m
}), F = s.readonly(), M = s.extend({
  redirectDomain: n.optional()
}).readonly(), ca = a.union([F, M]), pa = a.object({
  name: m
}).readonly(), sa = a.object({
  name: m
}).readonly(), d = t.exclude([t.enum.Hidden]), V = a.partialRecord(d, a.array(a.string()).readonly()), u = a.object({
  id: c,
  name: a.string().trim().min(1, "name must be non-empty").max(30),
  createdAt: a.coerce.date(),
  status: t,
  detailedStatus: C
}).readonly(), k = u.unwrap().extend({
  statusReasons: V
}).readonly(), S = a.object({
  owner: A,
  updatedAt: a.coerce.date()
}).readonly(), {
  common: da,
  admin: ua,
  union: D
} = p(k, S), Sa = w(D), N = a.object({
  name: a.string().trim().min(1, "name must be non-empty").optional(),
  ownerId: a.union([a.coerce.number().pipe(g), a.string().trim().min(1)]).optional(),
  recentlyCreated: a.preprocess((e) => e === "true" ? !0 : e === "false" ? !1 : e, a.boolean()).optional(),
  adUnitTypes: a.array(a.coerce.string().pipe(h)).optional(),
  statuses: a.array(d).optional()
}), ha = L.extend(b.shape).extend(
  N.shape
), v = u.unwrap().extend({
  clickRedirectType: r,
  adGroups: l,
  targetGroups: I,
  creativeGroups: x
}).readonly(), P = S.unwrap().extend({
  redirectDomain: n.optional()
}).readonly(), {
  common: ga,
  admin: Ca,
  union: la
} = p(v, P), B = R.unwrap().pick({
  id: !0,
  name: !0
}).readonly(), _ = f.unwrap().pick({
  id: !0,
  name: !0,
  adType: !0,
  adFormat: !0
}).extend({ assetsCount: a.number().int().nonnegative() }).readonly(), E = y.unwrap().pick({
  id: !0,
  name: !0
}), H = E.extend({
  pricingRules: a.array(G).readonly()
}).readonly(), ya = a.object({
  campaignId: c,
  targetGroups: a.array(B).readonly(),
  creativeGroups: a.array(_).readonly(),
  adGroups: a.array(H).readonly()
}).readonly();
export {
  o as CAMPAIGN_NAME_MAX_LENGTH,
  j as CampaignAdminMutationSchema,
  Ca as CampaignAdminViewSchema,
  T as CampaignCommonMutationSchema,
  ga as CampaignCommonViewSchema,
  N as CampaignListFilterSchema,
  S as CampaignListItemAdminFieldsSchema,
  ua as CampaignListItemAdminViewSchema,
  k as CampaignListItemCommonFieldsSchema,
  da as CampaignListItemCommonViewSchema,
  D as CampaignListItemSchema,
  ha as CampaignListQuerySchema,
  Sa as CampaignListSchema,
  ra as CampaignMutationSchema,
  la as CampaignSchema,
  H as CampaignStatisticsAdGroupSchema,
  _ as CampaignStatisticsCreativeGroupSchema,
  ya as CampaignStatisticsSchema,
  B as CampaignStatisticsTargetGroupSchema,
  V as CampaignStatusReasonsSchema,
  sa as CopyCampaignSchema,
  M as CreateCampaignAdminSchema,
  F as CreateCampaignCommonSchema,
  ca as CreateCampaignSchema,
  d as ListedCampaignStatusSchema,
  pa as RenameCampaignSchema
};
//# sourceMappingURL=schemas.js.map
